import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'La Nostra Storia', href: '/chi-siamo' },
    { name: 'Il Nostro Metodo', href: '/come-funziona' },
    { name: 'Napoli', href: '/agenzia-matrimoniale-napoli' },
    { name: 'Caserta', href: '/agenzia-matrimoniale-caserta' },
    { name: 'Roma', href: '/agenzia-matrimoniale-roma' },
    { name: 'Cerca Ultimi Iscritti', href: 'https://officinedelcuore.com/ricerca-iscritti', external: true },
    { name: 'Scrivici', href: '/contatti' },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <header className="header-elegant">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 logo-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_officine-cuore/artifacts/upmb4kcx_NUOVO%20LOGO%20OFFICINE2.webp" 
              alt="Officine del Cuore Logo" 
              className="h-14 w-auto"
            />
            <div className="flex flex-col">
              <span className="brand-name">Officine del Cuore</span>
              <span className="brand-tagline">Dal 2006</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              item.external ? (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link"
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`nav-link ${isActive(item.href) ? 'active' : ''}`}
                >
                  {item.name}
                </Link>
              )
            ))}
            <Link to="/contatti">
              <Button className="btn-primary">
                Richiedi Colloquio
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-burgundy p-2"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mobile-menu">
            {navigation.map((item) => (
              item.external ? (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mobile-nav-link"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`mobile-nav-link ${isActive(item.href) ? 'active' : ''}`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              )
            ))}
            <Link to="/contatti" onClick={() => setMobileMenuOpen(false)}>
              <Button className="btn-primary w-full mt-4">
                Richiedi Colloquio
              </Button>
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
